jQuery(document).ready(function($) {
	// (Optional) Active an item if it has the class "is-active"	
	// $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
    accordion_switch();
    $(".accordion > .accordion-item.meta_active").children(".metafield-rich_text_field").addClass("accordion-panel");
	
	$(".accordion > .accordion-item").click(function() {
		// Cancel the siblings
		$(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
		// Toggle the item
		$(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
	});
});

// jQuery(document).ready(function(){
// });
jQuery(window).resize(function(){
  accordion_switch();
});
function accordion_switch(){
  if(jQuery(window).width() < 768){
    jQuery('.product-other-inforn-accordion-wrapper.for_mobile').html(jQuery('.product-other-inforn-accordion-wrapper.for_desktop .accordion'));
  }else{
    // jQuery('.product-other-inforn-accordion-wrapper.for_desktop').html(jQuery('.product-other-inforn-accordion-wrapper.for_mobile .accordion'));
    // console.log(jQuery('.product-other-inforn-accordion-wrapper.for_mobile').html());
    if(jQuery('.product-other-inforn-accordion-wrapper.for_mobile').html() != ""){
      jQuery('.product-other-inforn-accordion-wrapper.for_desktop').append(jQuery('.product-other-inforn-accordion-wrapper.for_mobile .accordion'));
    }
  }
}